import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";

const NOTIFY_PARTY_VALIDATION_FIELDS = [
  "address_reference_number",
  "address_street",
  "address_street_line2",
  "address_city",
  "address_state",
  "address_country",
  "address_zipcode",
  "address_un_locode",
  "contact_name",
  "contact_phone",
  "contact_email",
];

/**
 * Custom hook for managing notify party validation logic
 * 1. If any notify party field is filled, all notify party fields are required
 * 2. If all notify party fields are empty, notify party is not required
 */
export default function useNotifyPartyValidation(
  partyType: string,
  setIsNotifyPartyRequired?: (isRequired: boolean) => void,
) {
  const { watch } = useFormContext();
  const [isRequired, setIsRequired] = useState(partyType === "consignee");

  useEffect(() => {
    if (partyType === "notify_party") {
      const allFieldsEmpty = NOTIFY_PARTY_VALIDATION_FIELDS.every((field) => !watch(`schedule.notify_party.${field}`));

      const newIsRequired = !allFieldsEmpty;
      setIsRequired(newIsRequired);
      setIsNotifyPartyRequired?.(newIsRequired);
    }
  }, [
    partyType,
    setIsNotifyPartyRequired,
    watch(`schedule.notify_party.address_reference_number`),
    watch(`schedule.notify_party.airport`),
    watch(`schedule.notify_party.seaport`),
    watch(`schedule.notify_party.contact_name`),
    watch(`schedule.notify_party.contact_phone`),
    watch(`schedule.notify_party.contact_email`),
  ]);

  return isRequired;
}
